import { storeSet, storeGet } from 'Helpers/localStorage'

/**
 * Get one or many values from window.localStorage.
 * @param {string | array} keys key to get
 * @param {string} prefix key prefix
 */

export const useStorage = (keys, prefix) => {
  const values = [].concat(keys).map(key => storeGet(key, prefix))

  const setters = []
    .concat(keys)
    .map(key => value => storeSet(key, value, prefix))

  return { values, setters }
}
